export const Error = 0;
export const Loading = 1;
export const Connected = 2;
export const Reconnecting = 3;
export const Disconnected = 4;
export const AdminConnectionEnded = 5;
export const DemoConnectionEnded = 6;
export const AlreadyConnected = 7;
export const TabDisconnected = 8;
